import { DialogContent, DialogTitle, Slide, Dialog } from "@mui/material";
import React, { useEffect } from "react";

import { language } from "../../language";
import HeaderText from "../HeaderText";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function DocumentScanningComponent({ handleClose, handleSave, handleCancel }) {
  function handleScannerIframeEvent({ data }) {
    if (data.message === "cancel") {
      handleClose();
      return;
    }
    if (data.message instanceof File) {
      handleSave({ file: data.message });
      handleClose();
      return;
    }
    if (data.error) {
      console.log(error);
    }
  }
  useEffect(() => {
    window.addEventListener("message", handleScannerIframeEvent);
    return () => {
      window.removeEventListener("message", handleScannerIframeEvent);
    };
  }, []);

  const onSave = (data) => {
    handleSave(data);
    handleClose();
  };

  return (
    <Dialog
      open
      TransitionComponent={Transition}
      fullScreen
      onClose={handleClose}
    >
      <DialogTitle>
        <HeaderText text={language.scanDocument} />
      </DialogTitle>
      <DialogContent>
        <iframe
          style={{ width: "100%", height: "99%" }}
          src={`/api/smartbpm/public/v1/redirect-manager/webscanner?no-cache=${new Date().getTime()}`}
        ></iframe>
      </DialogContent>
    </Dialog>
  );
}

// const mapDispatchToProps = {
//   fetchGetScanningProfile,
//   clearGetScanningProfile,
// };

export default DocumentScanningComponent;
